const HEADING_STATUS = 'Status';
const HEADING_BORROWER_NAME = 'Borrower';
const HEADING_TASK_NAME = 'Task Name';
const HEADING_UPLOADED_FILES = 'Uploaded Files';
const STATUS_LABEL_TODO = 'To Do';
const STATUS_LABEL_IN_REVIEW = 'In Review';
const STATUS_LABEL_COMPLETED = 'Completed';
const ACTIONS_UPLOAD = 'Upload';
const ACTIONS_SIGN_DISCLOSURES = 'Sign Disclosures';
const FILES_NONE = 'None';
const FILES_ONE_UPLOADED = ' file uploaded';
const FILES_UPLOADED = ' files uploaded';
const TASK_STATUS_PENDING = 'Pending';
const TASK_STATUS_PENDING_WITH_BORROWER = 'Pending with Borrower';
const TASK_STATUS_COMPLETED = 'Completed';
const TASK_TYPE_TRACKING_ITEM = 'Tracking Item';
const TASK_TYPE_SIGN_DISCLOSURES = 'Sign Disclosures';
const TASK_OTHER_NAME = 'Other Documents';
const TASK_OTHER_DESCRIPTION = 'Provide other documents requested by your Loan Advisor or Customer Advocate (if applicable).';
const WAITING_FOR_TEXT = ' WAITING FOR';
const ADDITIONAL_DOC = 'Additional Documents';
const TasksInfoMessage = 'In order to keep your loan on track for closing, you must complete the steps below.';
const EsignInfoMessage = 'Documents that provide information to borrowers about the terms and conditions of their mortgage loan, including interest rates, fees, and other costs associated with the loan. Please sign these disclosures, so we can move forward with your loan.';
const TASK_DESCREPTION_TEXT_LIMIT_WEB = 200;
const TASK_DESCREPTION_TEXT_LIMIT_MOBILE = 170;
const TASK_UPLOAD_ERROR_PRE_GATE_INCOMPLETE = 'Pre gate Incomplete';
const TASK_UPLOAD_ERROR_CORRECTION_NEEDED = 'Correction Needed';
const TASK_UPLOAD_ERROR_PROBLEM = 'Problem';
const TASK_UPLOAD_ERROR_MESSAGE = "Further documentation is required. We'll reach out with details.";
const TaskConstants = {
  HEADING_STATUS,
  HEADING_BORROWER_NAME,
  HEADING_TASK_NAME,
  HEADING_UPLOADED_FILES,
  STATUS_LABEL_TODO,
  STATUS_LABEL_IN_REVIEW,
  STATUS_LABEL_COMPLETED,
  ACTIONS_UPLOAD,
  ACTIONS_SIGN_DISCLOSURES,
  FILES_NONE,
  FILES_ONE_UPLOADED,
  FILES_UPLOADED,
  TASK_STATUS_PENDING,
  TASK_TYPE_TRACKING_ITEM,
  TASK_TYPE_SIGN_DISCLOSURES,
  TASK_STATUS_PENDING_WITH_BORROWER,
  TASK_STATUS_COMPLETED,
  TASK_OTHER_NAME,
  TASK_OTHER_DESCRIPTION,
  WAITING_FOR_TEXT,
  ADDITIONAL_DOC,
  noFilesUploaded: 'There are no files uploaded for now.',
  TasksInfoMessage,
  EsignInfoMessage,
  TASK_DESCREPTION_TEXT_LIMIT_WEB,
  TASK_DESCREPTION_TEXT_LIMIT_MOBILE,
  TASK_UPLOAD_ERROR_MESSAGE,
  TASK_UPLOAD_ERROR_CORRECTION_NEEDED,
  TASK_UPLOAD_ERROR_PRE_GATE_INCOMPLETE,
  TASK_UPLOAD_ERROR_PROBLEM
};
export default TaskConstants;
//# sourceMappingURL=index.js.map